import css from 'styled-jsx/css';
import { zIndex } from '../../../theme/theme';

const style = css.global`
  .add-users-wrapper {
    z-index: ${zIndex.allAroundModal};
  }
  .add-users-wrapper .ant-modal-header {
    padding: 15px;
    border-bottom: 0;
    padding-top: 20px;
    padding-bottom: 0px;
  }
  .add-users-wrapper .ant-modal-title {
    font-size: 24px;
  }
  .add-users-wrapper .ant-modal-body {
    padding: 15px;
    padding-top: 0;
  }
  .add-users-wrapper .ant-modal-close {
    width: 50px;
    height: 50px;
    color: black;
  }
  /* Legacy layout hack for the Individual form labels. Scoped to the form
     container so it can't disturb the modal header/close. */
  :global(.add-users-wrapper .create-user-contents span) {
    display: flex;
    flex-direction: column !important;
  }
`;

export default style;
